'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/24.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _reactRouter = require('react-router');

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopMembers = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    return _promise2.default.all([dispatch(experienceShopActions.getMembers())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    membersData: state.experienceShop.membersData
  };
}, (0, _extends3.default)({}, experienceShopActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopMembers, _Component);

  function ExperienceShopMembers() {
    (0, _classCallCheck3.default)(this, ExperienceShopMembers);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopMembers).call(this));

    _this.state = {
      currentPage: 0,
      filter: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopMembers, [{
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var getMembers = this.props.getMembers;

      if (getMembers) {
        this.setState({
          currentPage: page
        });
        getMembers('', page);
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var getMembers = this.props.getMembers;
      var filter = this.state.filter;

      var value = this.refs.searchInput.value;
      if (getMembers) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        getMembers(currentFilter, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var membersData = this.props.membersData;
      var currentPage = this.state.currentPage;

      var styles = require('./ExperienceShopMembers.scss');
      var membersDataShow = '';
      var totalPageNumber = 1;
      var errorLabel = '';
      if (membersData) {
        var experienceShopMember = membersData.experienceShopMember;
        var experienceShopMemberError = membersData.experienceShopMemberError;
        var experienceShopMemberRecordCount = membersData.experienceShopMemberRecordCount;
        var experienceShopMemberPagesize = membersData.experienceShopMemberPagesize;

        if (experienceShopMemberError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopMemberError });
        } else if (experienceShopMember instanceof Array && experienceShopMember.length > 0) {
          membersDataShow = experienceShopMember.map(function (member, index) {
            return _react2.default.createElement(
              'tr',
              { key: index, style: { background: index % 2 === 0 ? '#f9f8f8' : '' } },
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                currentPage * 15 + index + 1
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                member.memberName
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                member.mobile
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: '/personalcenter/experienceshop/experienceshopmembersdetails/' + member.memberId,
                    className: styles.bttn },
                  '查询'
                )
              )
            );
          });
        }
        totalPageNumber = parseInt(experienceShopMemberRecordCount / experienceShopMemberPagesize, 10);
        if (experienceShopMemberRecordCount % experienceShopMemberPagesize > 0) {
          ++totalPageNumber;
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.tydhy + ' ' + styles.disn },
        _react2.default.createElement(
          'ul',
          { className: styles.js_dd },
          _react2.default.createElement(
            'li',
            { className: styles.border },
            _react2.default.createElement(
              'span',
              null,
              '全部'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.js_all_shou },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text' }),
          _react2.default.createElement(
            'div',
            { className: styles.img, onClick: this.onSearch.bind(this) },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/shc.png', alt: '' })
          )
        ),
        _react2.default.createElement(
          'table',
          { className: styles.all_table },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { style: { width: '10%' } }),
            _react2.default.createElement('col', { style: { width: '20%' } }),
            _react2.default.createElement('col', { style: { width: '20%' } }),
            _react2.default.createElement('col', { style: { width: '10%' } })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '序号'
              ),
              _react2.default.createElement(
                'th',
                null,
                '姓名'
              ),
              _react2.default.createElement(
                'th',
                null,
                '联系方式'
              ),
              _react2.default.createElement(
                'th',
                null,
                ' '
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            membersDataShow
          )
        ),
        errorLabel,
        _react2.default.createElement('div', { className: 'clear' }),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber, onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return ExperienceShopMembers;
}(_react.Component), _class2.propTypes = {
  membersData: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  getMembers: _react.PropTypes.func,
  error: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ExperienceShopMembers;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopMembers/ExperienceShopMembers.js
 ** module id = 1472
 ** module chunks = 0
 **/